import { SET_FORM_DISPLAY_ERROR } from './constants';

export const setFormDisplayError = (stateId: string, displayError: boolean) => ({
  type: SET_FORM_DISPLAY_ERROR,
  stateId,
  displayError,
});
